/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Owned_EmptyInputs */

const cs_clients_owned_empty = /** @type {(inputs: Clients_Owned_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné nemovitosti jako vlastník.`)
};

const en_clients_owned_empty = /** @type {(inputs: Clients_Owned_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No properties linked as owner.`)
};

/**
* | output |
* | --- |
* | "No properties linked as owner." |
*
* @param {Clients_Owned_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_owned_empty = /** @type {((inputs?: Clients_Owned_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Owned_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_owned_empty(inputs)
	return cs_clients_owned_empty(inputs)
});